import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import CREATE_SESSION from '../mutations/CREATE_SESSION';

const useCreateSession = () => {
    const [ createNewSession ] = useMutation( CREATE_SESSION );

    const createSession = async ( saveData ) => {
        try {
            const response = await createNewSession( { variables: { input: saveData } } );
            const success = response?.data?.createSession?.id;
            
            if ( success ) {
                return {
                    success: true,
                    response: response?.data?.createSession
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error creating session', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            createSession
        };
    }, [] );
};

export default useCreateSession;
